import { FC, useEffect, useState } from 'react';
import ImageViewer from 'react-simple-image-viewer';

type Props = {
  urls: string[];
  onClose: () => void;
};

export const ImagesPreviewWrapper: FC<Props> = ({ urls, onClose }) => {
  useEffect(() => {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    document.getElementsByTagName('html')[0].style.overflow = 'hidden';

    return () => {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
      document.getElementsByTagName('html')[0].style.overflow = 'auto';
    };
  }, []);
  return (
    <ImageViewer
      src={urls}
      currentIndex={0}
      disableScroll={false}
      closeOnClickOutside={true}
      onClose={() => onClose()}
      backgroundStyle={{
        backgroundColor: 'rgba(0,0,0,0.4)',
        zIndex: 100
      }}
    />
  );
};
